var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{staticClass:"cell",attrs:{"data-testid":"orders-avatar"}},[_c('InitialAvatarIcon',{staticClass:"orders-avatar",attrs:{"icon":_vm.iconName,"size":"extra-small"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }